import { IConfigModule } from 'build/types/configs'

const config: IConfigModule = {
  version: '2.0.0',
  usePoints: true,
  filterPrizes: true,
  buttonsStart: ['xeerpa'],
  positiveLogoUrls: [],
  useSecondBackground: [
    '/terms-and-conditions',
    '/privacy-politics',
    '/profile',
    '/help',
    '/trivias',
    '/ranking/suscribe',
    '/ranking/suscribe/confirm',
    '/prizes',
    '/prizes/exchange',
    '/raffles/prizes',
    '/trivia/:id',
    '/trivia/',
    '/prizes/error',
    '/error/:errorid',
    '/auctions',
    '/referrals',
    '/raffles/error',
    '/home',
    '/memorama/list',
    '/memorama/win',
    '/memorama/game',
    '/album/start',
    '/album',
    '/signup',
    '/login',
    '/information/update',
    '/phone/update',
    '/phone',
    '/password-reset',
    '/mail/update',
    '/mail',
    '/address/update',
    '/address',
    '/update'
  ],
  imageStart: 'imageAndText',
  welcome: 'ImgAndText',
  legalAgeDate: true,
  routesLinks: [
    {
      path: '/memorama/list',
      text: 'Memorama'
    },
    {
      path: '/trivias',
      text: 'Trivias'
    },
    {
      path: '/redeem',
      text: 'Cargar códigos'
    },
    {
      path: '/profile',
      text: 'Mi información',
      small: true
    },
    {
      path: '/help',
      text: '¿Tienes alguna duda?',
      small: true
    },
    {
      path: '/terms-and-conditions',
      text: 'Ver términos y condiciones',
      small: true
    },
    {
      path: '/privacy-politics',
      text: 'Ver políticas de privacidad',
      small: true
    }
  ],
  routesHome: ['ProfileID'],
  routesProfile: ['information', 'address', 'phone', 'history', 'identificacion', 'movements'],
  privacyPolitics: 'MX',
  cookies: 'MX',
  notAvailableFields: ['instagram', 'consumptionCenter', 'nickName', 'sign'],
  trivia: {
    showIntroduction: false,
    interestsRequired: true
  },
  notShowFields: ['instagram'],
  modalBackgroundTrivias: false,
  error: {
    dontUseSecondBg: true
  },
  showPointsId: true,
  showModalMemorama: true,
  memorama: {
    dontShouldUseWhiteBg: true
  },
  album: {
    Consumo: {
      list: {
        urlRedirectAlbumComplete: '/album/start',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        isTakeFoto: true,
        useLoaderValidate: true,
        useCongrats: true,
        useCongratsDirect: true,
        howTakePhoto: true
      }
    },
    Card: {
      list: {
        handleClick: true,
        urlRedirectAlbumProgress: '/album/:id/ranking'
      },
      ranking: {
        titleUpload: true,
        viewMore: false,
        showSocial: 'like'
      },
      imageId: {
        showSocial: 'like'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        useLoaderValidate: true
      },
      congrats: {
        showButton3: true
      },
      profile: {
        showSocial: 'share',
        profileMultimediaOutputShare: 'base64'
      }
    },
    Ticket: {
      list: {
        urlRedirectAlbumComplete: '/album/start',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        isTakeFoto: false,
        useLoaderValidate: true,
        useCongrats: true,
        useCongratsDirect: true,
        howTakePhoto: true
      },
      congrats: {
        showButton2: true
      }
    },
    Foto: {
      list: {
        urlRedirectAlbumComplete: '/album/start',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        isTakeFoto: false,
        useLoaderValidate: true,
        useCongrats: true,
        useCongratsDirect: true,
        howTakePhoto: false,
        showImageConsent: true,
      },
      congrats: {
        showButton2: false,
        showButton3: false
      }
    }
  },
  captureBtnBgTransparent: true,
  useSecondTextureUrl: ['', 'start', 'trivia', 'agegate', 'redeem'],
  stepsNewVersion: true,
  prizes: {
    description: true,
    dontShowButtonCongrats: true
  },
  useImgInHome: false,
  addressUpdateBg: true,
  dontUseTexture: ['prizes', 'trivias', 'trivia', 'referrals', 'profile', 'help'],
  profile: {
    notShowButtonInformation: true,
    showButtonPoints: true
  },
  allowReferral: true,
  usePointsHome: true,
  wheel: {
    backgroundColors: ['white', '#CE8B14'],
    textColors: ['#CE8B14', '#FFF'],
    outerBorderColor: 'transparent',
    outerBorderWidth: 0,
    innerBorderColor: '#EB2517',
    innerBorderWidth: 60,
    innerRadius: 0,
    radiusLineColor: 'transparent',
    radiusLineWidth: 0,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    fontSize: 20,
    fontStyle: 'normal',
    textDistance: 60,
    perpendicularText: true
  },
  changeIdQr: false,
  tracking: false,
  rankingList: true
}

export default config
